import { render, staticRenderFns } from "./OutfieldFormationPieBox.vue?vue&type=template&id=ef1a5d88&scoped=true"
import script from "./OutfieldFormationPieBox.vue?vue&type=script&lang=js"
export * from "./OutfieldFormationPieBox.vue?vue&type=script&lang=js"
import style0 from "./OutfieldFormationPieBox.vue?vue&type=style&index=0&id=ef1a5d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a5d88",
  null
  
)

export default component.exports